import Phaser from 'phaser';
import ABCyaPhaser, { Images as ABCyaImages, Tweens as ABCyaTweens, Text as ABCyaText, Audio as ABCyaAudio } from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import { addButton, addSprite } from '../utils/Builder';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import FontKeys from '../FontKeys';
import InstructionsPopup from '../ui/InstructionsPopup';
import SelectLevelScreen, { moveOnScreen } from './SelectLevelScreen';
import { horizontalScreenTransisition } from './IntroScreen';
import GameGrid from '../game/GameGrid';
import LocalizationUIAssets from '../Localization-UIAssets';
import ABCyaLib from '@abcya/abcya_lib';

export default class GameScreen extends Phaser.Scene {
  static get KEY() { return 'GameScreen'; }

  create(isReset) {
    this.helpBlocker = null;

    const width = this.scale.width;
    const height = this.scale.height;

    const back = ABCyaImages.addImage(0, 0, UIAssetKeys._Bckg, this).setOrigin(0);
    const sizingRect = this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0x000000, 0).setOrigin(0);

    this.gameGrid = new GameGrid(this);
    this.add.existing(this.gameGrid);

    const gameCont = this.add.container();
    gameCont.add(sizingRect);

    const topBar = addSprite(gameCont, 'UIBarTop', 0, -334, true);
    const bottomBar = addSprite(gameCont, 'UIBarBottom', 0, 368, true);
    const levelArea = addSprite(gameCont, 'UILevelArea', 405, 0, false);

    this.menuBtn = addButton(this, 'MenuBtn', 50, 60, false);
    this.resetBtn = addButton(this, 'ResetBtn', 180, 60, false);
    this.helpBtn = addButton(gameCont, 'HelpBtn', 843, 60, false);

    const musicButton = ABCyaImages.addImage(978, 60, UIAssetKeys._UnmuteBtn, this);
    musicButton.setInteractive();

    if (gameData.MUSIC_ON === false) musicButton.setFrame(UIAssetKeys._MuteBtn);

    musicButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      ABCyaAudio.playOneShot(SoundAssetKeys._click, this);

      if (gameData.MUSIC_ON === false) {
        gameData.MUSIC_ON = true;
        musicButton.setFrame(UIAssetKeys._UnmuteBtn);
        this.sound.bg.play(SoundAssetKeys._Blobble_Jingle, { loop: true });
      }
      else {
        gameData.MUSIC_ON = false;
        musicButton.setFrame(UIAssetKeys._MuteBtn);
        this.sound.bg.stop();
      }
    });

    this.menuBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      ABCyaAudio.playOneShot(SoundAssetKeys._click, this);
      this.helpBlocker.setInteractive();

      ABCyaTweens.addTween(this.menuBtn, 200, { scaleX: 1.5, scaleY: 0.5, yoyo: true, easeParams: [1, 0.3] }, Phaser.Math.Easing.Bounce.Out,() => {
        horizontalScreenTransisition(this, SelectLevelScreen.KEY);
      });
    });

    this.resetBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      ABCyaAudio.playOneShot(SoundAssetKeys._click, this);
      this.helpBlocker.setInteractive();

      ABCyaTweens.addTween(this.resetBtn, 200, { scaleX: 1.5, scaleY: 0.5, yoyo: true, easeParams: [1, 0.3] }, Phaser.Math.Easing.Bounce.Out,() => {
        this.scene.restart(true);
      });
    });

    this.helpBtn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      ABCyaAudio.playOneShot(SoundAssetKeys._click, this);

      this.helpBtn.disableInteractive();
      ABCyaTweens.addTween(this.helpBtn, 200, { scaleX: 1.5, scaleY: 0.5, yoyo: true, easeParams: [1, 0.3] }, Phaser.Math.Easing.Bounce.Out,() => {
        this.helpBtnClicked();
        this.helpBtn.setInteractive();
      });
    });

    const greenColor = 0x1FD56E;

    const levelNumber = ABCyaText.addText(width / 2 + 3, -4, '60pt', greenColor, FontKeys._linotte_bold, gameData.CURRENT_LEVEL, this).setOrigin(0.5, 0);

    const gridWidth = this.gameGrid.getGridSize().width;
    const gridHeight = this.gameGrid.getGridSize().height;

    this.gameGrid.x = width / 2 - gridWidth / 2 - 80;
    this.gameGrid.y = height / 2 - gridHeight / 2 - 50;
    this.gameGrid.setScale(1.2);
    this.gameGrid.on('WIN', () => this.showWinDialog());

    const purple = 0xFF00FF;

    this.helpBlocker = this.add.rectangle(0,0, this.scale.width, this.scale.height, 0xffffff, 0).setOrigin(0);

    if (gameData.INSTRUCTIONS_SHOWN === false) {

      gameData.INSTRUCTIONS_SHOWN = true;
      this.helpBlocker.setInteractive();
      this.helpBtnClicked();
    }
    else {
      if (isReset !== true) {
        const instructions = ABCyaText.addText(width / 2 + 3, -4, '60pt', purple, FontKeys._linotte_bold, ABCyaPhaser.Localization.instance.getLocalizedString('base_instructions'), this).setOrigin(0.5)
          .setStroke('#520054', 6)
          .setWordWrapWidth(900);

        instructions.setScale(0);

        ABCyaTweens.addTween(instructions, 1000, { delay: 1000, scale: 1 }, Phaser.Math.Easing.Linear, () => {
          ABCyaTweens.addTween(instructions, 500, { delay: 2000, alpha: 0 }, Phaser.Math.Easing.Linear, () => {
            instructions.destroy();
          });
        });

        const posY = 400;

        ABCyaTweens.addTween(instructions, 1000, { y: posY, delay: 1000, easeParams: [1, 0.3] }, Phaser.Math.Easing.Bounce.Out);
      }
    }
  };

  showWinDialog() {

    ABCyaAudio.playOneShot(SoundAssetKeys._good_job, this);

    this.gameGrid.alpha = 0.5;

    this.dialog = ABCyaImages.addImage(530, 400, LocalizationUIAssets._GoodJobPopup, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0.5)
      .setScale(0.8);

    moveOnScreen(this.dialog, 'down', 1000, 0, Phaser.Math.Easing.Bounce.Out, [1, 0.3]);

    this.time.delayedCall(3000, () => this.nextScene());

    gameData.LEVELS_CLEARED[gameData.CURRENT_LEVEL - 1] = true;

    ABCyaLib.Storage.saveObject(gameData.storageKey, gameData.LEVELS_CLEARED);
  }

  nextScene() {

    ABCyaAudio.playOneShot('next_level', this);

    gameData.CURRENT_LEVEL++;
    if (gameData.CURRENT_LEVEL > 45) {
      gameData.CURRENT_LEVEL = 1;
    }

    horizontalScreenTransisition(this, GameScreenClone.KEY);
  }

  helpBtnClicked() {
    this.helpBlocker.setInteractive();
    this.helpBtn.setAlpha(0.6);
    this.dialog = new InstructionsPopup(this);
    this.add.existing(this.dialog);
    this.dialog.x += 240;
    this.dialog.y += 130;

    this.dialog.once(Phaser.GameObjects.Events.DESTROY, () => {
      this.helpBtn.setAlpha(1);
      this.helpBlocker.disableInteractive();
    });
  }
}

// done so screen transistions work
export class GameScreenClone extends GameScreen { // used because Phaser can not run two of the same scene
  static get KEY() { return 'GameScreenClone'; }

  constructor() {
    super({ key: GameScreenClone.KEY });
  }

  nextScene() {

    ABCyaAudio.playOneShot('next_level', this);

    gameData.CURRENT_LEVEL++;
    if (gameData.CURRENT_LEVEL > 45) {
      gameData.CURRENT_LEVEL = 1;
    }

    horizontalScreenTransisition(this, GameScreen.KEY);
  }
}